import { deleted, get, post, put } from 'utils/api';
import { DataResponse } from './response';

export interface ReportTemplate {
  reportTemplateId: string;
  reportName: string;
  reportTemplateName: string;
  isDefault: boolean;
  templateString: string;
  description?: string;
  resizable: string;
}

export interface IReportSavedServices {
  saveReportTemplate(data: object): Promise<DataResponse<null>>;
  updateReportTemplate(data: object): Promise<DataResponse<null>>;
  getListReportTemplate(reportName: string): Promise<DataResponse<ReportTemplate[]>>;
  deleteReportTemplate(reportTemplateId: string): Promise<DataResponse<null>>;
}

export function createReportSavedServices(): IReportSavedServices {
  return {
    saveReportTemplate: async (data: object) => {
      return (await post(`BC/save-report-template`, data)).data;
    },
    updateReportTemplate: async (data: object) => {
      return (await post(`BC/update-report-template`, data)).data;
    },
    getListReportTemplate: async (reportName: string) => {
      return (await get(`BC/get-list-report-template?reportName=${reportName}`)).data;
    },
    deleteReportTemplate: async (reportName: string) => {
      return (await deleted(`BC/delete-report-template?ReportTemplateId=${reportName}`)).data;
    },
  };
}
